import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["variant", "component", "children", "className"];
import React from 'react';
import { COLORS, FONTS } from '../styleVars';
import styled from 'styled-components';
var typoConstants = {
  headline: {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['24'],
    fontWeight: FONTS.regular,
    color: COLORS.black
  },
  title1: {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['20'],
    fontWeight: FONTS.regular,
    color: COLORS.white
  },
  title2: {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['20'],
    fontWeight: FONTS.regular,
    color: COLORS.darkestGrey
  },
  subheading: {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['16'],
    fontWeight: FONTS.regular,
    color: COLORS.black
  },
  body1: {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['14'],
    fontWeight: FONTS.regular,
    color: COLORS.black
  },
  body2: {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['14'],
    fontWeight: FONTS.regular,
    color: COLORS.darkerGrey
  },
  'body-strong': {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['14'],
    fontWeight: FONTS.bold,
    color: COLORS.black
  },
  caption1: {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['12'],
    fontWeight: FONTS.regular,
    color: COLORS.darkerGrey
  },
  caption2: {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['12'],
    fontWeight: FONTS.regular,
    color: COLORS.darkGrey
  },
  'caption-error': {
    fontFamily: FONTS.PTSans,
    fontSize: FONTS['12'],
    fontWeight: FONTS.regular,
    color: COLORS.neonRed
  },
  display1: {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['64'],
    fontWeight: FONTS.regular,
    color: COLORS.darkestGrey
  },
  display2: {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['42'],
    fontWeight: FONTS.regular,
    color: COLORS.black
  },
  headline2: {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['24'],
    fontWeight: FONTS.regular,
    color: COLORS.darkestGrey
  },
  result: {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['20'],
    fontWeight: FONTS.regular,
    color: COLORS.black
  },
  'result-running': {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['20'],
    fontWeight: FONTS.regular,
    color: COLORS.fupaSecondary
  },
  subheading2: {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['16'],
    fontWeight: FONTS.regular,
    color: COLORS.darkestGrey
  },
  'button-primary': {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['14'],
    fontWeight: FONTS.regular,
    color: COLORS.white
  },
  'button-secondary': {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['14'],
    fontWeight: FONTS.regular,
    color: COLORS.fupaSecondary
  },
  'button-sub': {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['14'],
    fontWeight: FONTS.regular,
    color: COLORS.darkerGrey
  },
  'button-disabled': {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['14'],
    fontWeight: FONTS.regular,
    color: COLORS.grey
  },
  caption3: {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['12'],
    fontWeight: FONTS.regular,
    color: COLORS.darkerGrey
  },
  'caption3-active': {
    fontFamily: FONTS.Oswald,
    fontSize: FONTS['12'],
    fontWeight: FONTS.regular,
    color: COLORS.fupaSecondary
  }
};
var TypoContainer = styled.span.withConfig({
  componentId: "sc-lhxcmh-0"
})(["font-family:", ";font-size:", ";font-weight:", ";color:", ";"], function (_ref) {
  var typeStyle = _ref.typeStyle;
  return typeStyle.fontFamily;
}, function (_ref2) {
  var typeStyle = _ref2.typeStyle;
  return typeStyle.fontSize;
}, function (_ref3) {
  var typeStyle = _ref3.typeStyle;
  return typeStyle.fontWeight;
}, function (_ref4) {
  var typeStyle = _ref4.typeStyle;
  return typeStyle.color;
});
var componentValues;

(function (componentValues) {
  componentValues["span"] = "span";
  componentValues["h1"] = "h1";
  componentValues["h2"] = "h2";
  componentValues["h3"] = "h3";
  componentValues["h4"] = "h4";
  componentValues["h5"] = "h5";
  componentValues["h6"] = "h6";
  componentValues["p"] = "p";
  componentValues["label"] = "label";
})(componentValues || (componentValues = {}));

var Typography = function Typography(_ref5) {
  var variant = _ref5.variant,
      _ref5$component = _ref5.component,
      component = _ref5$component === void 0 ? getDefaultComponent(variant) : _ref5$component,
      children = _ref5.children,
      className = _ref5.className,
      props = _objectWithoutProperties(_ref5, _excluded);

  var typeStyle = typoConstants[variant]; // The `as` polymorphic-prop defines how the TypoContainer will be rendered. This is a functionality of styled-components:
  // https://styled-components.com/docs/api#as-polymorphic-prop

  return /*#__PURE__*/React.createElement(TypoContainer, _extends({
    className: className,
    as: component,
    typeStyle: typeStyle
  }, props), children);
};

var getDefaultComponent = function getDefaultComponent(variant) {
  switch (variant) {
    case 'headline':
      return componentValues.h2;

    case 'subheading2':
      return componentValues.h3;

    default:
      return componentValues.span;
  }
};

export { Typography };
//# sourceMappingURL=Typography.js.map